import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { AddOrderItemMutationRequest, AddOrderItemMutationResponse, AddOrderItemPathParams, AddOrderItemQueryParams, AddOrderItem400, AddOrderItem500 } from "../types/AddOrderItem";

/**
 * @summary Добавить новый товар в заказ
 * @link /api/orders/:orderId/items/:itemId
 */

export function useAddOrderItem <TData = AddOrderItemMutationResponse, TError = AddOrderItem400 | AddOrderItem500, TVariables = AddOrderItemMutationRequest>(orderId: AddOrderItemPathParams["orderId"], itemId: AddOrderItemPathParams["itemId"], params: AddOrderItemQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/orders/${orderId}/items/${itemId}`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
